import { Navigate, Route } from "react-router-dom";

import { List, Create, Edit } from "../components";

const productCategoryRoutes = [
    <Route index element={<Navigate to="list" replace />} key={"product-category:index"} />,
    <Route path="list" element={<List />} key={"product-category:list"} />,
    <Route path="create" element={<Create />} key={"product-category:create"} />,
    <Route path=":categoryId" element={<Edit />} key={"product-category:edit"} />,
];

export default productCategoryRoutes;
